module.exports = __webpack_public_path__ + "img/logo.2f44a154.svg";